import { FormFieldBase } from './form-field-base.model';

export class FormFieldCheckBox extends FormFieldBase<boolean> {
  override controlType = 'checkbox';
}
